// @ts-nocheck
import { withBreakpointObserver } from '@studiometa/js-toolkit';
import { Tabs } from '@studiometa/ui';

/**
 * TabsBreakpoints component
 */
export default class TabsBreakpoints extends withBreakpointObserver(Tabs) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'TabsBreakpoints',
  };

  /** @inheritdoc */
  enableItem(tabItem) {
    super.enableItem(tabItem);
    tabItem.btn.classList.add('is-active');
    tabItem.content.classList.add('is-active');
  }

  /** @inheritdoc */
  disableItem(tabItem) {
    super.disableItem(tabItem);
    tabItem.btn.classList.remove('is-active');
    tabItem.content.classList.remove('is-active');
  }

  /**
   * Destroyed
   */
  destroyed() {
    this.$refs.btn.forEach((item) => {
      item.classList.remove('is-active');
    });

    this.$refs.content.forEach((item) => {
      item.classList.remove('is-active');
      item.style.position = '';
      item.style.opacity = '';
      item.style.pointerEvents = '';
      item.style.visibility = '';
    });
  }
}
